import BaseApiService from './api.base.service'

class OpinionRequirementsApiService extends BaseApiService {
  constructor() {
    super('opinionrequirements')
  }

  getByUserOdata(params) {
    return this.callGet('/odata', params)
  }

  getExperts(query, take) {
    if (query && take) {
      return this.callGet(`/experts?query=${query}&take=${take}`)
    } else if (query) {
      return this.callGet(`/experts?query=${query}`)
    } else if (take) {
      return this.callGet(`/experts?take=${take}`)
    }
    return this.callGet('/experts')
  }

  getExpertsByOpinionRequirementId(id) {
    return this.callGet(`${id}/experts`)
  }
}

export const opinionRequirementsApi = new OpinionRequirementsApiService()
